import { getArticleCompletionStatus } from "../CommonComponents/article.helpers";
import {
  TestBuyProductWithCriteria,
  Criterion,
} from "@coworker/types/lib/testbuy";
import { TestbuyItems } from "@coworker/apprestructured/src/testbuy/types/testbuyItems";

export const getRemainingArticlesProps = (
  articles: TestBuyProductWithCriteria[]
): TestbuyItems => {
  return {
    testbuyItems:
      articles.filter(
        (article) => getArticleCompletionStatus(article) !== "Completed"
      ) ?? [],
  };
};

export const createCounter = (
  numberOfArticles: number,
  totalNumberOfArticles: number
): string => {
  return `${numberOfArticles} / ${totalNumberOfArticles}`;
};

const getNumberOfFailedCriteria = (criteria: Criterion[]): number => {
  return criteria.filter((criterion) => criterion.state === "NOT_OK").length;
};

const sortArticlesByFailedCriteria = (
  articles: TestBuyProductWithCriteria[]
): TestBuyProductWithCriteria[] => {
  return articles.sort(
    (first, second) =>
      getNumberOfFailedCriteria(second.criteria) -
      getNumberOfFailedCriteria(first.criteria)
  );
};

export const getCompletedArticlesProps = (
  articles: TestBuyProductWithCriteria[]
): TestbuyItems => {
  const filteredArticles = articles.filter(
    (article) => getArticleCompletionStatus(article) === "Completed"
  );

  return {
    testbuyItems: sortArticlesByFailedCriteria(filteredArticles),
  };
};
